import { useEffect, useState } from 'react';

/**
 * Hook to handle camera ready state with a workaround for onCameraReady not being called consistently
 * Reference: https://github.com/expo/expo/issues/34957#issuecomment-3059791935
 *
 * @param enabled - Whether to enable the camera ready state (default: true)
 * @param delay - Delay in milliseconds before setting camera ready (default: 500)
 * @returns Object containing cameraReady state and setCameraReady function
 */
export const useCameraReady = (enabled = true, delay = 500) => {
  const [cameraReady, setCameraReady] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // Set camera ready after a small delay
    // This is a workaround for onCameraReady not being called consistently
    const timer = setTimeout(() => {
      setCameraReady(true);
    }, delay);

    return () => {
      clearTimeout(timer);
      setCameraReady(false);
    };
  }, [enabled, delay]);

  return {
    cameraReady,
    setCameraReady,
  };
};
